// extracted by mini-css-extract-plugin
export var container = "_az-0";
export var icon = "_az-1";
export var text = "_az-2";